import {component, EntityData, field, identifier, LocalisableEntityData, transientField} from "@fedeltapointofsale/data-client";

export class CategoryReferenceData extends EntityData<CategoryReferenceData> {
    @identifier categoryId: number;
    @field name: string;
}

export class CategoryData extends LocalisableEntityData<CategoryData> {
    public static readonly COLOR_DEFAULT = "#00ffffff";

    private _reorderableInApp: boolean;

    @identifier categoryId: number;
    @field name: string;
    @field exportCode: string;
    @field colour: number;
    @field applyMinimumAge: boolean;
    @component parent: CategoryReferenceData;

    @field get reorderableInApp(): boolean {
        return this._reorderableInApp;
    }

    set reorderableInApp(reorderableInApp: boolean) {
        this._reorderableInApp = reorderableInApp || null;
    }

    @transientField get rgbaColour(): string {
        const rgb: number = this.colour & 0xFFFFFF;
        const alpha: number = (this.colour >>> 24) & 0xFF;
        return "#" + ("00000" + rgb.toString(16)).slice(-6) + ("0" + alpha.toString(16)).slice(-2);
    }

    set rgbaColour(rgbaColour: string) {
        const colour: number = Number(rgbaColour.replace("#", "0x"));
        const rgb = colour >>> 8;
        const alpha = colour & 0xFF;
        this.colour = (alpha << 24) | rgb;
    }
}

